import React from "react";

/**
 * Renders a JSON-LD script tag. Pass a serializable object or array.
 */
const JsonLd = ({ data }) => {
  if (data == null) return null;
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: JSON.stringify(data),
      }}
    />
  );
};

export default JsonLd;
